import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import Pagination from '@/components/Pagination.vue'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { dateFormat } from '@/utils/index'

    const maxDate = 1000*60*60*24*90
    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaasChannelData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const today = new Date()
    const filters = reactive({
            start_time:      dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()-1}`), 
            end_time:        dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()-1}`), 
            channel_name:'',
            channel_no:'',
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
        props:{
            expandTrigger: 'hover',
            value:'id',
            label:'lable',
            checkStrictly: true,
            children:'options'
        },
        city:'',
        options:[],
    })
    const tableData = ref([])
    const total = ref(0)
    const disabledStartDate = (date) => { // 返回不可用日期
        return date.getTime() > Date.now() - 24*60*60*1000
    }
    const disabledEndDate = (date) => { // 返回不可用日期
        var start = new Date(filters.start_time).getTime() - 24*60*60*1000
        //@ts-ignore
        var end = date.getTime() 
        return date.getTime() > Date.now() - 24*60*60*1000 || filters.start_time  && date.getTime() > start + maxDate || end < start
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('port/channel/getChannelAmount', filters).then(res => {
            const { code, data, msg,count } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    const channelList = ref([])

const onGetChannelList = () => {
    proxy.$http.get(`/dsapi/trade/channel_info?status=1&is_xiaoshou=1`).then((res ) => {
        const {code, data, msg} = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        channelList.value = data
    })
}
    const onChannelChange = (val) => {
        if(val){
            let splitChannel = val?.split('-'); 
            filters.channel_name = splitChannel[0];
            filters.channel_no = splitChannel[1];
        }     
    }
    const handleClear = () => {
        filters.channel_name = ''
        filters.channel_no = ''
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
        onGetChannelList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.channel_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.channel_name) = $event)),
        filterable: "",
        clearable: "",
        placeholder: "渠道名称",
        onChange: onChannelChange,
        onClear: handleClear
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.channel_name,
              value: item.channel_name +'-' + item.channel_no
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.start_time) = $event)),
        "disabled-date": disabledStartDate,
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期"
      }, null, 8, ["modelValue"]),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.end_time) = $event)),
        "disabled-date": disabledEndDate,
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"text-align":"right","margin-right":"20px","margin-bottom":"10px","font-size":"12px"} }, "刷新最新数据", -1)),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "销售额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_remain_money",
          label: "最新渠道余额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "xiaoshou_name",
          label: "销售"
        }),
        _createVNode(_component_el_table_column, {
          prop: "yunying_name",
          label: "运营"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})